export default function Marquee({ items, accent = "#CCFF00" }) {
  const repeated = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-black"
      style={{ background: accent }}
    >
      <div className="flex animate-marquee whitespace-nowrap py-3">
        {repeated.map((item, idx) => (
          <div
            key={idx}
            className="flex items-center gap-6 px-6 text-black font-bold uppercase tracking-[0.25em] text-sm"
          >
            <span>{item}</span>
            <span aria-hidden="true">●</span>
          </div>
        ))}
      </div>
    </div>
  );
}
